module.exports = __webpack_public_path__ + "static/media/blogCountIcon.89daaa71.svg";